var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco4Proceso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico_4_proceso",
    transform: "translate(-1370 -1911)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8049",
    "data-name": "Group 8049",
    transform: "translate(1429.382 1947.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8132",
    "data-name": "Group 8132",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8131",
    "data-name": "Group 8131",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19660",
    "data-name": "Path 19660",
    d: "M822.19,959.267l-23.818-15.439v-10.67H753.629v10.67l-23.817,15.439a8.548,8.548,0,0,0-3.917,7.207v34.765a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V966.474a6.584,6.584,0,0,1,.807-3.147h42.252a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-40.6a6.227,6.227,0,0,1,.547-.4l24.047-15.587h20.576a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-19.9v-8.211h40.761v9.762l24.725,16.027a6.6,6.6,0,0,1,3.009,5.536v16.717a1,1,0,0,0,.995,1h0a1,1,0,0,0,1-1V966.474A8.559,8.559,0,0,0,822.19,959.267Z",
    transform: "translate(-725.895 -933.158)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6462",
    "data-name": "Rectangle 6462",
    width: 4.096,
    height: 1.991,
    rx: 0.996,
    transform: "translate(56.933 49.521)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6463",
    "data-name": "Rectangle 6463",
    width: 18.184,
    height: 1.991,
    rx: 0.996,
    transform: "translate(30.808 49.521)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3.39
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19661",
    "data-name": "Path 19661",
    d: "M825.308,1171.151c-7.889,1.82-16.453,3.9-24.594,2.881-6.135-.766-12.139-2.435-18.154-3.814-6.482-1.487-13.084-2.924-19.759-3.068-4.745-.1-9.913.469-13.576,3.621v51.7a6.828,6.828,0,0,0,6.828,6.828h83.064a6.828,6.828,0,0,0,6.828-6.828v-55.3C838.984,1167.8,832.093,1169.585,825.308,1171.151Z",
    transform: "translate(-740.613 -1080.782)",
    fill: "#80cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19662",
    "data-name": "Path 19662",
    d: "M824.113,1091.125v75.917a5.055,5.055,0,0,1-5.055,5.055h-86.12a5.055,5.055,0,0,1-5.055-5.055v-70.689a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v70.689a7.046,7.046,0,0,0,7.046,7.046h86.12a7.046,7.046,0,0,0,7.046-7.046v-75.917a1,1,0,0,0-1-1h0A1,1,0,0,0,824.113,1091.125Z",
    transform: "translate(-725.892 -1032.196)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3.39
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6460",
    "data-name": "Rectangle 6460",
    width: 228,
    height: 228,
    transform: "translate(1370 1911)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 107.233,
    cy: 107.233,
    r: 107.233,
    transform: "translate(1375 1918)",
    fill: "#fff",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4Proceso);
export default __webpack_public_path__ + "static/media/ico_4_proceso.56aaa7308063ff5b429f6edba74118e6.svg";
export { ForwardRef as ReactComponent };